import {Button, Col, Row, Table} from "antd";
import React, {useMemo} from "react";
import {formatValue} from "../../../views/apps/ai-assistant/AIAssistantChat";
import {Spacer} from "../../DesignSystem/Spacer/Spacer";
import CloudDownloadOutlined from "@ant-design/icons/lib/icons/CloudDownloadOutlined";
import {assistantService} from "../../../services/assistantService";
import {InfoCircleOutlined} from "@ant-design/icons";

export const ResponseDataFrame = ({objectType, objectId, value, context, limit = 5}) => {

    const data = useMemo(() => {
        const dataset = JSON.parse(value).data;
        return dataset.slice(0, limit);
    }, [value]); // eslint-disable-line

    const size = useMemo(() => {
        return context.size;
    }, [context]); // eslint-disable-line

    const columns = useMemo(() => {

        return JSON.parse(value).schema.fields.map(field => {
            return {
                title: field.name,
                dataIndex: field.name,
                key: field.name,
                width: 100,
                render: (v) => formatValue(field.type, v),
                onHeaderCell: () => ({
                    style: {whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}, // Ellipsis for long headers
                }),
                onCell: () => ({
                    style: {whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}, // Ellipsis for long cells
                }),
            }
        });

    }, [value]); // eslint-disable-line

    const handleDownloadData = (filename) => {
        assistantService.downloadDataFrame(objectType, objectId, filename).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename); // or get from response headers
            document.body.appendChild(link);
            link.click();
            link.remove();
        });
    }

    const footer = () => {
        if (size == 0 || limit >= size) {
            return undefined;
        } else {
            return <div style={{textAlign: "center", fontSize: '10px', color: 'silver'}}><InfoCircleOutlined size={"small"}/> We show only
                first {limit} records from {size}, but you can download it.</div>
        }
    }

    if (!data || !columns || !context) {
        return <></>
    }

    return <Row>
        <Col span={24}>
            <Button onClick={() => handleDownloadData(context.filename)}>Download as CSV</Button>{' '}
            <Button onClick={() => handleDownloadData(context.excelFilename)}>Download as Excel</Button>
            <Spacer/>
            <Table columns={columns} dataSource={data} pagination={false} sticky={true} size={"small"}
                   scroll={{y: '75vh', x: 'max-content'}}
                   footer={() => footer()}
            />
        </Col>
    </Row>

}